import { get } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const assessmentsData = async (listId) => {
  const builder = new UrlBuilder(`/assessments/assess-data/${listId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getAssessmentData = async (listId) => {
  const builder = new UrlBuilder(`/assessments/get-assessment-data/${listId}`);

  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
